<template>
  <div>
    <div class="container-buttons">
      <button
        v-if="isCronJobRunning"
        class="btn-custom btn-cron-cobranca mb-3"
        @click="toggleCronJob"
      >
        <i class="fa fa-phone"></i> Parar disparo automático de ligações de cobrança
      </button>
      <button v-else-if="!isInProgress" class="btn-custom btn-cobranca mb-3" @click="invokeCalls">
        <i class="fa fa-phone"></i> Disparar ligações de cobrança
      </button>
      <button
        v-else-if="isInProgress"
        class="btn-custom btn-stop-cobranca mb-3"
        @click="cleanQueue"
      >
        <i class="fa fa-ban"></i> Parar processo de ligações
      </button>
      <a @click="showConfigModal">
        <i class="fa fa-cog btn-config mt-2 mr-3"></i>
      </a>
    </div>
    <modal name="config" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Configurações</p>
      <hr />
      <form @submit.prevent="updateConfig" class="container">
        <div class="row">
          <div class="col-md-6">
            <fg-input
              label="Ramal"
              required
              v-model="branchConfig"
              min="1"
              step="1"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input
              label="Min. p/ poder ligar para o mesmo cliente"
              required
              v-model="intervalConfig"
              min="1"
              step="1"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            ></fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <fg-input
              label="URL de ligação da URA"
              type="url"
              required
              placeholder="https://uracallurl.com.br/clicktocall.php"
              v-model="urlConfig"
            ></fg-input>
          </div>
        </div>
        <span>Ativar ligação automática</span>
        <div class="row">
          <div class="col-md-4">
            <label class="switch">
              <input v-model="cronJobRunningSwitchState" type="checkbox" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="col-md-8">
            <button class="btn-custom btn-cobranca btn-modal" type="submit" round>Salvar</button>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
    <modal name="phoneList" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Telefones de {{ phoneModal.name }}</p>
      <hr />
      <div class="modalPhones">
        <ul>
          <li v-for="phone in phoneModal.phones" :key="phone">
            <i class="fa fa-volume-control-phone"></i>
            {{ phone }}
          </li>
        </ul>
      </div>
    </modal>
    <p v-show="isCronJobRunning && isCronJobIdle"><b>ATENÇÃO: Fora do horário de envio, o disparo automático não está adicionando números na fila</b></p>
    <card
      :title="`Cobrança de Pontos Bloqueados (${pagination.totalResults})`"
      subTitle="Pontos Bloqueados"
    >
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Bairro</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="client in clients" :key="client.CONTRA">
              <td>{{ client.CONTRA }}</td>
              <td>{{ client.NOME || "-" }}</td>
              <td>{{ client.CPFCGC || "-" }}</td>
              <td>{{ client.BAIRRO || "-" }}</td>
              <td>
                <p-button
                  v-show="client.isInQueue === true"
                  type="warning"
                  outline
                  icon
                  title="Na fila para ligação de cobrança"
                  disabled
                >
                  <i class="fa fa-volume-control-phone"></i>
                </p-button>
                <p-button
                  v-show="!client.isInQueue"
                  @click.prevent.native="addToQueue(client.CONTRA, getPhoneNumbers(client))"
                  type="success"
                  outline
                  icon
                  title="Disparar ligação de cobrança"
                >
                  <i class="fa fa-phone"></i>
                </p-button>
                <p-button
                  @click.prevent.native="showPhoneModal({ name: client.NOME, phones: getPhoneNumbers(client) })"
                  type="info"
                  outline
                  icon
                  title="Visualizar telefones"
                >
                  <i class="fa fa-book"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>

    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    isCronJobIdle() {
      const date = new Date();
      const dayOfWeek = date.getDay();
      const hour = date.getHours();
      // mon to friday
      if (dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 9 && hour <= 20) {
        return false;
      }
      // saturday
      else if (dayOfWeek == 6 && hour >= 9 && hour <= 14) {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      isInProgress: false,
      isCronJobRunning: false,
      cronJobRunningSwitchState: false,
      clients: [],
      pagination: {
        totalResults: 0,
        totalPages: 1,
        prevPage: 1,
        currentPage: 1,
        nextPage: 1,
        perPage: 20
      },
      branchConfig: "0",
      urlConfig: "",
      intervalConfig: 0,
      phoneModal: {
        name: "",
        phones: []
      }
    };
  },
  methods: {
    showConfigModal() {
      this.fetchConfig();
      this.$modal.show("config");
    },
    showPhoneModal(data) {
      this.phoneModal = data;
      this.$modal.show("phoneList");
    },
    getPhoneNumbers(client) {
      const phones = [];
      if (client.TEL_NUM1) phones.push(`${client.TEL_DDD1}${client.TEL_NUM1}`);
      if (client.TEL_NUM2) phones.push(`${client.TEL_DDD2}${client.TEL_NUM2}`);
      if (client.TEL_NUM3) phones.push(`${client.TEL_DDD3}${client.TEL_NUM3}`);
      if (client.TEL_NUM4) phones.push(`${client.TEL_DDD4}${client.TEL_NUM4}`);
      if (client.TEL_NUM5) phones.push(`${client.TEL_DDD5}${client.TEL_NUM5}`);
      if (client.TEL_NUM6) phones.push(`${client.TEL_DDD6}${client.TEL_NUM6}`);
      return phones;
    },
    async addToQueue(id, phones) {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá realizar uma ligação de cobrança para este cliente, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.$http.post(
            "/queue/add",
            { id, phones },
            { params: { queue: "blocked" } }
          );
          this.isInProgress = true;
          this.setIsInQueue(id, true);

          Swal.fire({
            title: "Sucesso!",
            text: "Uma ligação para este cliente foi adicionado na fila",
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação",
            icon: "error"
          });
        }
      }
    },
    async toggleCronJob() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá alternar o estado do serviço de ligações automático, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          const { data } = await this.$http.post("/queue/cron");
          this.isCronJobRunning = data.running;
          this.cronJobRunningSwitchState = this.isCronJobRunning;
          Swal.fire({
            title: "Sucesso!",
            text: `O serviço foi ${
              this.isCronJobRunning ? "ligado" : "desligado"
            }.`,
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação",
            icon: "error"
          });
        }
      }
    },
    async invokeCalls() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá realizar uma ligação para todos os clientes bloqueados, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.$http.post("/queue/start", undefined, {
            params: { queue: "blocked" }
          });
          this.isInProgress = true;

          for (let i = 0; i < this.clients.length; i++) {
            this.clients[i].isInQueue = true;
          }
          this.$forceUpdate();

          Swal.fire({
            title: "Sucesso!",
            text: "Os pontos foram adicionados a fila de ligações de cobrança",
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação",
            icon: "error"
          });
        }
      }
    },
    async cleanQueue() {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá parar as ligações de cobrança em andamento, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.$http.post("/queue/clean", undefined, {
            params: { queue: "blocked" }
          });
          this.isInProgress = false;

          for (let i = 0; i < this.clients.length; i++) {
            this.clients[i].isInQueue = false;
          }
          this.$forceUpdate();

          Swal.fire({
            title: "Sucesso!",
            text: "A fila de ligações de cobrança foi cancelada",
            icon: "success"
          });
        } catch (err) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível concluir esta ação",
            icon: "error"
          });
        }
      }
    },
    async fetchProgress() {
      const { data } = await this.$http.get("/queue/jobs", {
        params: { queue: "blocked" }
      });
      const clientIds = data.map(job => job.data.clientId);

      this.isInProgress = data.length > 0;
      this.updateIsInQueue(clientIds);
    },
    async fetchPoints() {
      const { data, headers } = await this.$http.get("points/all", {
        params: {
          status: 43,
          limit: this.pagination.perPage,
          page: this.pagination.currentPage
        }
      });
      const { data: jobs } = await this.$http.get("/queue/jobs", {
        params: { queue: "blocked" }
      });
      const clientIds = jobs.map(job => job.data.clientId);

      this.clients = data;
      this.updateIsInQueue(clientIds);

      this.pagination.totalResults = +headers["x-total-results"];
      this.pagination.totalPages = +headers["x-total-pages"];
      this.pagination.prevPage = +headers["x-total-pages"];
      this.pagination.currentPage = +headers["x-current-page"];
      this.pagination.nextPage = +headers["x-next-page"];
      this.pagination.perPage = +headers["x-per-page"];
    },
    async fetchConfig() {
      const { data } = await this.$http.get("/config");

      this.branchConfig = data.blockedQueueBranchLine;
      this.urlConfig = data.queueUrl;
      this.intervalConfig = data.intervalToCallSameClient;
      this.cronJobRunningSwitchState = data.isQueueEnabled;
      this.isCronJobRunning = data.isQueueEnabled;
    },
    async updateConfig() {
      if (this.intervalConfig < 10) {
        Swal.fire({
          title: "Ops!",
          text: "Intervalo para ligar para o mesmo cliente muito baixo.",
          icon: "warning"
        });
        return;
      }
      try {
        await Promise.all([
          this.$http.patch("/config", {
            blockedQueueBranchLine: this.branchConfig,
            queueUrl: this.urlConfig,
            intervalToCallSameClient: +this.intervalConfig,
            isQueueEnabled: this.cronJobRunningSwitchState,
          }),
        ]);
        this.isCronJobRunning = this.cronJobRunningSwitchState;

        Swal.fire({
          title: "Sucesso!",
          text:
            "Valores atualizados, eles serão utilizados para as novas ações.",
          icon: "success"
        });
      } catch (err) {
        Swal.fire({
          title: "Ops!",
          text: "Não foi possível atualizar os valores.",
          icon: "error"
        });
      }
    },
    async updatePagination({ currentPage }) {
      this.pagination.currentPage = currentPage;
      await this.fetchPoints();
    },
    setIsInQueue(id, toggle) {
      const client = this.clients.find(client => client.CONTRA === id);
      if (!client) {
        return;
      }
      client.isInQueue = toggle;
      this.$forceUpdate();
    },
    updateIsInQueue(clientIds) {
      for (let i = 0; i < this.clients.length; i++) {
        if (clientIds.includes(this.clients[i].CONTRA)) {
          this.clients[i].isInQueue = true;
        } else {
          this.clients[i].isInQueue = false;
        }
      }
      this.$forceUpdate();
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig(),
        this.fetchProgress(),
        this.fetchPoints()
      ]);

      this.fetchProgressInterval = setInterval(
        this.fetchProgress.bind(this),
        10000
      );
    } catch (err) {
      Swal.fire({
        title: "Ops!",
        text: "Não foi possível carregar as informações",
        icon: "error"
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.fetchProgressInterval);
  }
};
</script>

<style lang="scss" scoped>
.modal-title {
  font-size: 20px;
}
.btn-modal {
  padding: 10px 60px;
}
.container-body {
  display: flex;

  p {
    font-size: 16px;
  }
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }

  &.btn-stop-cobranca {
    background: #b80a0a;

    &:hover {
      background: #700202;
    }
  }

  &.btn-cron-cobranca {
    background: #ebb000;

    &:hover {
      background: #9c7500;
    }
  }

  &.btn-modal {
    padding: 10px 50px;
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}

.btn-outline-warning {
  border-color: #ffc107;
  color: #ffc107;

  &:hover {
    background: #ffc107 !important;
    background-color: #ffc107 !important;
    border-color: #ffc107;
  }
}

.modalPhones {
  ul {
    font-size: 16px;
    li {
      list-style: none;
    }
  }
}
</style>
<style>
@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>
